export const regex = {
  number: /^[0-9]*$/,
  email: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
  nik: /^[0-9]{6,6}$/,
  pn: /^[0-9]{8,8}$/,
  password: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,20}$/,
  telepon: /\+?([ -]?\d+)+|\(\d+\)([ -]\d+)/,
  uuid: /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
  // COBA MENU GENERAL
  general: /general\/bri-score/,
  // REGEX MENU EVALUASI TINDAK LANJUT
  tindaklanjut: /hasil-tindak-lanjut/,
  mikrotindakLanjut: /hasil-tindak-lanjut\/mikro/,
  akuisisitindaklanjut: /hasil-tindak-lanjut\/mikro\/akuisisi/,
  konsumertindakLanjut: /hasil-tindak-lanjut\/konsumer/,
  retensitindaklanjut: /hasil-tindak-lanjut\/mikro\/retensi/,
  // REGEX MENU MIKRO
  akuisisiMikro: /mikro\/akuisisi/,
  akuisisiSimpananMikro: /mikro\/akuisisi\/simpanan/,
  akuisisiPinjamanMikro: /mikro\/akuisisi\/pinjaman/,
  retensiMikro: /mikro\/retensi/,
  retensiSimpananMikro: /mikro\/retensi\/simpanan/,
  simpanan: /simpanan/,
  pinjaman: /pinjaman/,
  sudah: /Sudah/,
};
